import { Action } from '../../definitions/types';
import * as Actions from '../actions/actions-consts';

export default function selectedSubtype(
  state: string = null,
  action: Action<any> // tslint:disable-line no-any
): string {
  switch (action.type) {
    case Actions.SET_SUBTYPE:
      return action.payload;
    default:
      return state;
  }
}
